import { useEffect, useState } from "react";
import { CheckCircle2 } from "lucide-react";
import { spaceOf } from "@/lib/spaces";
import { airhorn, fireConfetti } from "@/lib/fun";

const KEY = "wb-celebrated";
const seen = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } };

export const CompletionParty = ({ items, w }) => {
  const [show, setShow] = useState(null);
  useEffect(() => {
    if (!items?.length || !w) return undefined;
    const done = seen();
    const fresh = items.filter((c) => !done.includes(c.id));
    if (!fresh.length) return undefined;
    localStorage.setItem(KEY, JSON.stringify([...done, ...fresh.map((c) => c.id)].slice(-200)));
    if (!w.celebrate) return undefined;
    fireConfetti("fireworks");
    setTimeout(() => fireConfetti("classic"), 900);
    if (w.airhorn) airhorn();
    setShow(fresh);
    const t = setTimeout(() => setShow(null), 7000);
    return () => clearTimeout(t);
  }, [items, w]);
  if (!show) return null;
  return (
    <div className="pointer-events-none fixed inset-x-0 top-[22%] z-[70] flex flex-col items-center gap-3 px-6" data-testid="wall-completion-party">
      {show.map((c) => {
        const who = spaceOf(c.completed_by || c.space);
        return (
          <div key={c.id} className="fade-up flex max-w-4xl items-center gap-4 rounded-3xl border-2 bg-card/95 px-8 py-5 shadow-2xl backdrop-blur-xl" style={{ borderColor: who.color }}>
            <CheckCircle2 className="h-12 w-12 shrink-0 text-emerald-400" />
            <div>
              <p className="font-display text-3xl font-extrabold" style={{ color: who.color }}>{who.name} smashed it!</p>
              <p className="mt-1 text-xl text-foreground/90">{c.title}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};
